import { render, staticRenderFns } from "./tc-search.vue?vue&type=template&id=5846ef98&scoped=true&"
import script from "./tc-search.vue?vue&type=script&lang=js&"
export * from "./tc-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5846ef98",
  null
  
)

export default component.exports